module.exports = __webpack_public_path__ + "static/media/OTD.446a8576.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/Home/OTD.png
// module id = 418
// module chunks = 0